<div class="subtitle">
  If the email address has an account, an email will be sent with a link to
  reset your password.
</div>

<div class="mt-10">
  <app-shared-button (click)="openSignIn()">Sign in</app-shared-button>
</div>
